module.exports = __webpack_public_path__ + "static/media/a32.83fde5fa.pdf";